<template>
   <section class="breadcrumbs-custom">
    <!-- <div class="parallax-container">
        <div class="material-parallax parallax"><img src="/assets/images/breadcrumbs-bg.jpg" alt="breadcrumbs"></div>
        <div class="breadcrumbs-custom-body parallax-content context-dark">
        <div class="container">
            <h2 class="breadcrumbs-custom-title">Reset Password</h2>
        </div>
        </div>
    </div> -->
    <div class="breadcrumbs-custom-footer">
        <div class="container">
        <ul class="breadcrumbs-custom-path">
            <li><router-link to="/">Home</router-link></li>            
            <li class="active">Reset Password</li>
        </ul>
        </div>
    </div>
    </section>

   <section class="section section-xxl bg-default">
      <div class="container">
         <div class="row row-40 justify-content-center">         
            <div class="col-sm-10 col-md-6">
               <div class="inset-xl-right-50">
                  <h3>Reset Password</h3>
                  <div class="group group-middle group-button-1">
                     <h6>Enter your new password below.</h6>
                  </div>
                  <!-- RD Mailform-->
                  <form @submit.prevent="submitForm" class="rd-form rd-mailform" novalidate="novalidate">
                  <div class="form-wrap" :class="{ 'has-error': v$.resetPasswordData.password.$error || store.isServeError && serverError.hasOwnProperty('password') }" style="position: relative;">
                     <input v-model="resetPasswordData.password" class="form-input form-control-has-validation" id="reset-password" :type="showPassword ? 'text' : 'password'" data-constraints="@Required" style="padding-right: 40px;">
                     <label class="form-label rd-input-label" for="reset-password">New Password</label>
                     <span @click="showPassword = !showPassword" style="position: absolute; right: 15px; top: 15px; cursor: pointer; z-index: 10; font-size: 1.2em; color: #a0a0a0;">
                        <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                     </span>
                     <span v-if="v$.resetPasswordData.password.$error" class="form-validation">
                        {{ passwordErrorMsg }}
                     </span>
                     <span v-if="store.isServeError && serverError.hasOwnProperty('password')" class="form-validation">{{ serverError.password[0] }}</span>
                  </div>
                  <div class="form-wrap" :class="{ 'has-error': v$.resetPasswordData.password_confirmation.$error || store.isServeError && serverError.hasOwnProperty('password_confirmation') }" style="position: relative;">
                     <input v-model="resetPasswordData.password_confirmation" class="form-input form-control-has-validation" id="reset-password-confirmation" :type="showPasswordConfirmation ? 'text' : 'password'" data-constraints="@Required" style="padding-right: 40px;">
                     <label class="form-label rd-input-label" for="reset-password-confirmation">Confirm Password</label>
                     <span @click="showPasswordConfirmation = !showPasswordConfirmation" style="position: absolute; right: 15px; top: 15px; cursor: pointer; z-index: 10; font-size: 1.2em; color: #a0a0a0;">
                        <i :class="showPasswordConfirmation ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                     </span>
                     <span v-if="v$.resetPasswordData.password_confirmation.$error" class="form-validation">
                        {{ passwordConfirmationErrorMsg }}
                     </span>
                     <span v-if="store.isServeError && serverError.hasOwnProperty('password_confirmation')" class="form-validation">{{ serverError.password_confirmation[0] }}</span>
                  </div>
                  <div class="group-sm group-middle group-button-1">
                     <button class="button button-lg button-primary button-zakaria" type="submit" :disabled="isSubmitting">
                        <span v-if="isSubmitting">Submitting...</span>
                        <span v-else>Reset Password</span>
                     </button>
                  </div>
                  <p v-if="errorMessage" class="text-danger mt-3">{{ errorMessage }}</p>
                  <p v-if="successMessage" class="text-success mt-3">{{ successMessage }}</p>
                  </form>
               </div>
            </div>
         </div>
      </div>
   </section>
</template>
<script setup>
import { onMounted, computed, ref } from 'vue'
import { useHead } from '@unhead/vue'
import { useCartStore } from '@/stores/cart'
import useVuelidate from '@vuelidate/core'
import { required, minLength, sameAs } from '@vuelidate/validators'
import { useAuthStore } from '@/stores/authStore'
import { storeToRefs } from 'pinia'
import { useRoute } from 'vue-router'

const cartStore = useCartStore()
const route = useRoute()

const store = useAuthStore()
const { resetPasswordData, isSubmitting, successMessage, errorMessage, serverError } = storeToRefs(store)

const showPassword = ref(false)
const showPasswordConfirmation = ref(false)

useHead({
  title: 'Reset Password - CakeGurus',
  meta: [
    {
      name: 'description',
      content: 'Reset your password for CakeGurus.',
    },
  ],
})

onMounted(() => {
    cartStore.loadCart()
    
    // Extract query parameters from URL
    if (route.query.token) {
        resetPasswordData.value.token = route.query.token
    }
    if (route.query.email) {
        resetPasswordData.value.email = route.query.email
    }
    
    const scriptId = 'script-js-script'
    const existingScript = document.getElementById(scriptId)
    if (existingScript) {
        existingScript.remove()
    }
    const newScript = document.createElement('script')
    newScript.src = '/assets/js/script.js'
    newScript.id = scriptId
    document.body.appendChild(newScript)
})

const rules = computed(() => {
  return {
    resetPasswordData: {
      password: { required, minLength: minLength(8) },
      password_confirmation: { 
          required, 
          sameAsPassword: sameAs(resetPasswordData.value.password)
      },
    }
  }
})

const v$ = useVuelidate(rules, { resetPasswordData })

const passwordErrorMsg = computed(() => {
  if (!v$.value.resetPasswordData.password.$dirty) return ''
  if (!v$.value.resetPasswordData.password.required) return 'Password is required'
  if (!v$.value.resetPasswordData.password.minLength) return 'Password must be at least 8 characters'
  return ''
})

const passwordConfirmationErrorMsg = computed(() => {
  if (!v$.value.resetPasswordData.password_confirmation.$dirty) return ''
  if (!v$.value.resetPasswordData.password_confirmation.required) return 'Please confirm your password'
  if (!v$.value.resetPasswordData.password_confirmation.sameAsPassword) return 'Passwords do not match'
  return ''
})

async function submitForm() {
  v$.value.$touch()
  if (v$.value.$invalid) {
    errorMessage.value = 'Please fix the form errors before submitting.'
    return
  }
  
  if (!resetPasswordData.value.token || !resetPasswordData.value.email) {
      errorMessage.value = 'Invalid reset password link. Missing token or email.'
      return
  }
  
  store.resetPassword()  
}
</script>
